const styles = {
  rootClx: 'flex w-full items-center justify-between bg-black px-4 py-2 text-white sm:px-6',
  brandCtaClx:
    'flex cursor-pointer items-center gap-2 p-1 outline-offset-2 focus-visible:outline focus-visible:outline-2',
  logoClx: 'h-6 w-auto sm:h-7',
  wordmarkClx: 'hidden h-4 w-auto min-[325px]:block sm:h-5',
  backCtaClx:
    'flex cursor-pointer items-center gap-2 p-1 outline-offset-2 focus-visible:outline focus-visible:outline-2',
  backArrowClx: 'h-5 w-5 sm:h-6 sm:w-6',
  backTextClx: 'sr-only text-sm font-medium min-[325px]:not-sr-only sm:text-base',
};

export default styles;
